import React, { useEffect, useState } from "react";
import Link from "../Link";
import "./productCard.css";
import { useImageBackground } from "../Hooks/useImageBackground";
import { getGetter, dispatch } from "../reactStore/vuexBridge";

export default function ImgBlock({
  product,
  isExclusive,
  isDesktop,
  prdIndex,
}) {
  const baseUrl = process.env.IMG_BASE_URL + process.env.PRODUCT_IMG;
  const pclass = `prd${product.id}${product.category}img`;
  const imageContainerRef = useImageBackground("1080:1440", "#FFEBE7");
  const [wishlistItemsIDs, setWishlistItemsIDs] = useState(
    getGetter("wishlistItemsIDs")
  );

  function navigateToProd(url) {
    return `/product/${url}?get=${product.genderType || 0}`;
  }

  function getround(val) {
    return val ? parseInt(val, 10) : 0;
  }

  function isExternalLink(navLink) {
    return navLink && typeof navLink === "string" && navLink.startsWith("http");
  }

  function triggerAnimation(e) {
    e.target.classList.add("wishlistAnimationNew");
    setWishlistItemsIDs(getGetter("wishlistItemsIDs"));
    setTimeout(function () {
      e.target.classList.remove("wishlistAnimationNew");
    }, 1000);
  }

  function updateWishlist(item, e, index) {
    e.stopPropagation();
    if (wishlistItemsIDs && item && item.id) {
      const data = {
        category: item.category && item.category.name,
        gender_type: item.genderType && item.genderType.toString(),
        images: item.images,
        parent_prod_id: item.id,
        price: item.price,
        prod_id: item.id,
        prod_type: item.prodType,
        prod_qty: item.prodQty,
        quantity: 1,
        product: item.product,
        size: item?.size || "",
        prArtist: (item.artist && item.artist.name.replace("\u0099", "")) || "",
        spl_price: item.splPrice || item.spl_price,
        url_key: item.product_slug,
        platform: "web",
      };
      if (wishlistItemsIDs[item.id]) {
        dispatch("UPDATE_WISHLIST", {
          operation: "delete",
          type: "products",
          data,
        }).then(() => {
          setWishlistItemsIDs(getGetter("wishlistItemsIDs"));
          setTimeout( () => {
            triggerAnimation(e);
          },100)
        });
      } else {
        dispatch("UPDATE_WISHLIST", {
          operation: "add",
          type: "products",
          data,
        }).then(() => {
          setWishlistItemsIDs(getGetter("wishlistItemsIDs"));
          setTimeout( () => {
            triggerAnimation(e);
          },100)
        });
      }
    }
  }

  return (
    <div>
      <div
        className={`productlist product-card custom-full-border ${
          product?.tiptiles ? "h-full" : ""
        }`}
        id={
          product
            ? product?.tiptiles
              ? `productlist-tiptile-${product?.tiptiles?.id}`
              : `productlist-${product.id}`
            : null
        }
      >
        {product && !product.tiptiles ? (
          <Link href={navigateToProd(product.product_slug)}>
            <div
              ref={imageContainerRef}
              className={`imgBlockNew custom-border listhover ${pclass}`}
            >
              {isDesktop ? (
                <div
                  className="listhoverimg"
                  style={{
                    backgroundImage: `url(${baseUrl + product.images[1]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
              ) : null}
              <img
                src={baseUrl + product.images[0]}
                alt={product.name}
                loading="lazy"
                className="custom-border img-auto"
              />
              {(product?.prodType === 1 || product?.prodType === 6) &&
              product?.stock <= 0 ? (
                <div className="souled-out-image-blur">Souled Out</div>
              ) : product?.prodType === 3 && product?.prodQty <= 0 ? (
                <div className="souled-out-image-blur">Souled Out</div>
              ) : null}
            </div>

            <div className={`mx-1`}>
              <div
                style={isDesktop ? { display: "grid" } : { display: "flex" }}
              >
                <h5
                  className="text-left product-name-text"
                  style={{ color: "#585C70" }}
                >
                  {product.product}
                </h5>
                <div
                  className={`wishlistIconNew pl-1 pb-2 pr-1 ${
                    wishlistItemsIDs?.[String(product.id)]
                      ? "wishlistActive"
                      : "wishlist"
                  }`}
                  onClick={(e) => {
                    e.preventDefault(); // stop <Link> navigation
                    e.stopPropagation(); // stop bubbling
                    updateWishlist(product, e, prdIndex);
                  }}
                ></div>
              </div>

              <div className="listprice ecltext">
                <span>
                  {product?.category?.name
                    ? product?.category?.name
                    : product?.artistname || ""}
                </span>
              </div>

              {/* ✅ Price block always renders */}
              <div className="row">
                <div className="col-12 special-products_pricingicing">
                  <div className="price-block">
                    {isExclusive && getround(product?.exclusivePrice) ? (
                      // Exclusive price
                      <div>
                        <span
                          className="membership-product-price"
                          style={{ color: "#121212" }}
                        >
                          <span style={{ color: "#121212" }}>
                            Membership Price{" "}
                          </span>
                          <span className="fsemibold">
                            ₹ {getround(product.exclusivePrice)}
                          </span>
                        </span>
                        <span className="product-price-strike">
                          ₹ {getround(product.price)}
                        </span>
                      </div>
                    ) : product?.splPrice ? (
                      // Non-exclusive with special price
                      <>
                        <span className="offer fsemibold">
                          ₹ {getround(product.splPrice)}
                        </span>
                        <span
                          className="product-price"
                          style={{
                            textDecoration: "line-through",
                            color: "#ccc",
                            marginLeft: "8px",
                          }}
                        >
                          ₹ {getround(product.price)}
                        </span>
                        <span className="percentage-off">
                          ₹{" "}
                          {getround(product.price) - getround(product.splPrice)}{" "}
                          OFF
                        </span>
                      </>
                    ) : (
                      // Fallback: show original price
                      <span className="offer fsemibold">
                        ₹ {getround(product.price)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ) : (
          <div className={`imgBlockNew tiptileBlock h-full`}>
            {product?.tiptiles?.isClickable &&
            product?.tiptiles?.navLink &&
            isExternalLink(product?.tiptiles?.navLink) ? (
              <a
                href=""
                className="h-full"
                herf={product.tiptiles.navLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={
                    isDesktop
                      ? product?.tiptiles?.image
                      : product?.tiptiles?.mobileImage
                  }
                  alt={product.tiptiles.name}
                  loading="lazy"
                  className="h-full w-full fit-cover customFade-active"
                />
              </a>
            ) : product.tiptiles.isClickable && product.tiptiles.navLink ? (
              <Link href={product.tiptiles.navLink} className="h-full">
                <img
                  src={
                    isDesktop
                      ? product.tiptiles.image
                      : product.tiptiles.mobileImage
                  }
                  alt={product.tiptiles.name}
                  loading="lazy"
                  className="h-full w-full fit-cover customFade-active"
                />
              </Link>
            ) : (
              <div className="h-full pointer-none">
                <img
                  src={
                    isDesktop
                      ? product.tiptiles.image
                      : product.tiptiles.mobileImage
                  }
                  alt={product.tiptiles.name}
                  loading="lazy"
                  className="h-full w-full fit-cover customFade-active"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/react-component/product-card/productCard.jsx